import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Layout, Table, Button, Icon, notification } from "antd";

import classes from "./Reporting.css";

import isAuthenticated from "../../utils/isAuthenticated";

import { getFileReporting, getFileReportingByDepot } from "../../api/requests";

import {
  getReportsUsersReadPermission,
  getReportsSitesReadPermission,
  getReportsSubjectsReadPermission,
  getReportsDrugInventoryReadPermission,
  getReportsDrugInventoryByReportPermission,
  getReportsInventoryAllVialsReadPermission,
  getReportsFinancePermission,
  getReportsFinanceInvoiceSummaryReadPermission,
  getReportsFinanceSubjectSummaryReadPermission,
  getReportsFinanceSummaryReadPermission,
  getReportsCombinedReadPermission,
  getReportsConsentReadPermission,
  getReportsRequiredDocumentsPerSiteReadPermission, getReportsViewDocumentMetadata,
  getReportsEndOfStudyBlindedReadPermission,
  getReportsEndOfStudyUnblindedReadPermission,
  getReportsPermutedBlocksBlindedReadPermission,
  getReportsPermutedBlocksUnblindedReadPermission,
} from "../../reducers/user/selectors";
import { withNamespaces } from "react-i18next";

const { Content } = Layout;

const reportTypes = {
  PDF: "pdf",
  CSV: "csv",
  TXT: "txt",
};

class Reporting extends React.Component {
  state = {
    loadingReports: [],
  };

  downloadReport = async (report, type, label) => {
    try {
      if (
        report === "drug_all_vials" ||
        report === "user" ||
        report === "combined_reports" ||
        report === "consent" ||
        report === "document_metadata"
      ) {
        try {
          await getFileReporting(report, type);
          this.openNotification();
        } catch (e) {
          notification.error({
            message: "Error",
            description: this.props.i18n.t(
              "NamespaceReporting:Something went wrong"
            ),
          });
        }
      } else {
        this.setState((state) => ({
          loadingReports: { ...state.loadingReports, [report]: true },
        }));

        let data = null;

        if (report === "reports_drug_inventory_by_depot_read") {
          const response = await getFileReportingByDepot(report, type);
          data = response.data;
        } else {
          const response = await getFileReporting(report, type);
          data = response.data;
        }
        const blob = new Blob([data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${label}.${type}`;
        link.click();

        this.setState((state) => ({
          loadingReports: { ...state.loadingReports, [report]: false },
        }));
      }
    } catch (e) {
      console.log(e);
    }
  };

  openNotification = () => {
    notification.open({
      message: "Success",
      description: this.props.i18n.t(
        "NamespaceReporting:A report email has been sent"
      ),
    });
  };

  reports = [
    {
      label: this.props.i18n.t("NamespaceReporting:Site status report"),
      name: "site",
      permission: this.props.reportsSitesReadPermission,
    },
    {
      label: this.props.i18n.t(
        "NamespaceReporting:User account report (E-mail Report)"
      ),
      name: "user",
      permission: this.props.reportsUsersReadPermission,
    },
    {
      label: this.props.i18n.t("NamespaceReporting:Subject listing"),
      name: "subject",
      permission: this.props.reportsSubjectsReadPermission,
    },
    {
      label: this.props.i18n.t(
        "NamespaceReporting:Study drug inventory summary report - by manufacturer and depot"
      ),
      name: "reports_drug_inventory_by_depot_read",
      permission: this.props.reportsDrugInventoryByReportPermission,
    },
    {
      label: this.props.i18n.t(
        "NamespaceReporting:Study drug inventory summary report - by site"
      ),
      name: "drug",
      permission: this.props.reportsDrugInventoryReadPermission,
    },
    {
      label: this.props.i18n.t(
        "NamespaceReporting:Study drug inventory - all drug ids (E-mail Report)"
      ),
      name: "drug_all_vials",
      permission: this.props.reportsInventoryAllVialsReadPermission,
    },
    {
      label: this.props.i18n.t("Finance"),
      name: "finance",
      permission: this.props.reportsFinancePermission,
    },
    {
      label: this.props.i18n.t("NamespaceReporting:Finance-Invoice Summary"),
      name: "finance_invoice_summary",
      permission: this.props.reportsFinanceInvoiceSummaryReadPermission,
    },
    {
      label: this.props.i18n.t("NamespaceReporting:Finance-Subject summary"),
      name: "finance_subject_summary",
      permission: this.props.reportsFinanceSubjectSummaryReadPermission,
    },
    {
      label: this.props.i18n.t("NamespaceReporting:Finance summary"),
      name: "finance_summary",
      permission: this.props.reportsFinanceSummaryReadPermission,
    },
    {
      label: this.props.i18n.t("Combined reports (E-mail Report)"),
      name: "combined_reports",
      permission: this.props.reportsCombinedReadPermission,
    },
    {
      label: this.props.i18n.t("Consent (E-mail Report)"),
      name: "consent",
      permission: this.props.reportsConsentReadPermission,
    },

    {
      label: this.props.i18n.t("Site specific required documents"),
      name: "required_documents",
      permission: this.props.reportsRequiredDocumentsPerSiteReadPermission,
    },

    {
      label: this.props.i18n.t("Missing documents report"),
      name: "missing_documents",
      permission: this.props.reportsRequiredDocumentsPerSiteReadPermission,
    },

    {
      label: this.props.i18n.t("Document metadata (E-mail Report)"),
      name: "document_metadata",
      permission: this.props.reportsViewDocumentMetadata,
    },
    {
      label: this.props.i18n.t("End of study Blinded"),
      name: "end_of_study_blinded",
      permission: this.props.reportsEndOfStudyBlindedReadPermission,
    },
    {
      label: this.props.i18n.t("End of study Unblinded"),
      name: "end_of_study_unblinded",
      permission: this.props.reportsEndOfStudyUnblindedReadPermission,
    },
    {
      label: this.props.i18n.t("End of study All Treatment Codes Unblinded"),
      name: "end_of_study_all_treatment_codes_unblinded",
      permission: this.props.reportsEndOfStudyUnblindedReadPermission,
    },
    {
      label: this.props.i18n.t("End of study Subject Treatment Codes Unblinded"),
      name: "end_of_study_subject_treatment_codes_unblinded",
      permission: this.props.reportsEndOfStudyUnblindedReadPermission,
    },
    {
      label: this.props.i18n.t("Permuted Blocks Blinded Report"),
      name: "permuted_blocks_blinded_report",
      permission: this.props.reportsPermutedBlocksBlindedReadPermission,
    },
    {
      label: this.props.i18n.t("Permuted Blocks Unblinded Report"),
      name: "permuted_blocks_unblinded_report",
      permission: this.props.reportsPermutedBlocksUnblindedReadPermission,
    },
    {
      label: this.props.i18n.t("NamespaceReporting:Inactive Subjects listing"),
      name: "inactive_subject",
      permission: this.props.reportsSubjectsReadPermission,
    }
  ];

  columns() {
    return [
      {
        key: "report",
        title: this.props.i18n.t("NamespaceReporting:Report"),
        render: (item) => item.label,
      },
      {
        key: "actions",
        title: this.props.i18n.t("Download"),
        render: (item) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
            }}
          >
            {item.permission &&
              !["combined_reports", "finance_subject_summary", "required_documents", "document_metadata",
                "end_of_study_blinded", "end_of_study_unblinded", "end_of_study_all_treatment_codes_unblinded",
                "end_of_study_subject_treatment_codes_unblinded", "permuted_blocks_blinded_report", "permuted_blocks_unblinded_report"].includes(
                item.name
              ) && (
                <Button
                  style={{ marginRight: "1rem", flex: 1 }}
                  onClick={() =>
                    this.downloadReport(item.name, reportTypes.PDF, item.label)
                  }
                  disabled={
                    this.state.loadingReports[item.name] || !item.permission
                  }
                >
                  PDF
                </Button>
              )}
            {item.permission && (
              <Button
                style={{ marginRight: "1rem", flex: 1 }}
                onClick={() =>
                  this.downloadReport(item.name, reportTypes.CSV, item.label)
                }
                disabled={
                  this.state.loadingReports[item.name] || !item.permission
                }
              >
                CSV
              </Button>
            )}
            {item.permission &&
              !["end_of_study_blinded", "end_of_study_unblinded"].includes(
                item.name
              ) &&  (
              <Button
                style={{ marginRight: "1rem", flex: 1 }}
                onClick={() =>
                  this.downloadReport(item.name, reportTypes.TXT, item.label)
                }
                disabled={
                  this.state.loadingReports[item.name] || !item.permission
                }
              >
                TXT
              </Button>
            )}
            {this.state.loadingReports[item.name] && (
              <div
                style={{
                  position: "absolute",
                  paddingTop: "0.3rem",
                  background: "rgba(255,255,255,0.9)",
                  textAlign: "center",
                  width: "100%",
                  height: "100%",
                }}
              >
                <span
                  style={{
                    marginRight: "1rem",
                    fontSize: "0.9rem",
                    fontWeight: "bold",
                    color: "var(--primary-color)",
                  }}
                >
                  {this.props.i18n.t(
                    "NamespaceReporting:Report generation in progress"
                  )}
                </span>
                <Icon
                  style={{
                    color: "var(--primary-color)",
                  }}
                  type="loading"
                />
              </div>
            )}
          </div>
        ),
      },
    ];
  }

  render() {
    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("Reporting")}
            </h3>

            <Table
              columns={this.columns()}
              dataSource={this.reports.filter(({ permission }) => permission)}
              className={classes.table}
              pagination={false}
              rowKey="name"
            />
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  reportsSitesReadPermission: getReportsSitesReadPermission(state),
  reportsUsersReadPermission: getReportsUsersReadPermission(state),
  reportsSubjectsReadPermission: getReportsSubjectsReadPermission(state),
  reportsDrugInventoryReadPermission: getReportsDrugInventoryReadPermission(
    state
  ),
  reportsInventoryAllVialsReadPermission: getReportsInventoryAllVialsReadPermission(
    state
  ),
  reportsDrugInventoryByReportPermission: getReportsDrugInventoryByReportPermission(
    state
  ),
  reportsFinancePermission: getReportsFinancePermission(state),
  reportsFinanceInvoiceSummaryReadPermission: getReportsFinanceInvoiceSummaryReadPermission(
    state
  ),
  reportsFinanceSubjectSummaryReadPermission: getReportsFinanceSubjectSummaryReadPermission(
    state
  ),
  reportsFinanceSummaryReadPermission: getReportsFinanceSummaryReadPermission(
    state
  ),
  reportsCombinedReadPermission: getReportsCombinedReadPermission(state),
  reportsRequiredDocumentsPerSiteReadPermission: getReportsRequiredDocumentsPerSiteReadPermission(state),
  reportsViewDocumentMetadata: getReportsViewDocumentMetadata(state),
  reportsConsentReadPermission: getReportsConsentReadPermission(state),
  reportsEndOfStudyBlindedReadPermission: getReportsEndOfStudyBlindedReadPermission(state),
  reportsEndOfStudyUnblindedReadPermission: getReportsEndOfStudyUnblindedReadPermission(state),
  reportsPermutedBlocksBlindedReadPermission: getReportsPermutedBlocksBlindedReadPermission(state),
  reportsPermutedBlocksUnblindedReadPermission: getReportsPermutedBlocksUnblindedReadPermission(state),
});

export default isAuthenticated(
  connect(mapStateToProps)(withNamespaces()(Reporting))
);



// WEBPACK FOOTER //
// ./src/containers/Reporting/Reporting.js